// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1wd8zd40 {
  border-width: 1px;
  border-style: solid;
  border-radius: var(--_18w76bwb);
  padding: var(--_18w76bwg) var(--_18w76bwd);
  margin-bottom: var(--_18w76bwd);
}
._1wd8zd40:last-child {
  margin-bottom: var(--_18w76bw9);
}
._1wd8zd41 {
  gap: var(--_18w76bwd);
  width: var(--_18w76bw1u);
  align-items: flex-start;
  padding-bottom: var(--_18w76bwd);
  border-bottom: 1px solid var(--_18w76bw25);
}
._1wd8zd42 {
  width: var(--_18w76bwk);
  height: var(--_18w76bwk);
}
._1wd8zd43 {
  padding-top: var(--_18w76bwh);
  gap: var(--_18w76bwd);
  flex-direction: column;
}
._1wd8zd44 {
  gap: var(--_18w76bwd);
  width: var(--_18w76bw1u);
}
._1wd8zd45 {
  flex: 1;
}
._1wd8zd46 {
  flex: 0 0 82px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0CAA0C;EAC1C,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,OAAO;AACT;AACA;EACE,cAAc;AAChB","sourcesContent":["._1wd8zd40 {\n  border-width: 1px;\n  border-style: solid;\n  border-radius: var(--_18w76bwb);\n  padding: var(--_18w76bwg) var(--_18w76bwd);\n  margin-bottom: var(--_18w76bwd);\n}\n._1wd8zd40:last-child {\n  margin-bottom: var(--_18w76bw9);\n}\n._1wd8zd41 {\n  gap: var(--_18w76bwd);\n  width: var(--_18w76bw1u);\n  align-items: flex-start;\n  padding-bottom: var(--_18w76bwd);\n  border-bottom: 1px solid var(--_18w76bw25);\n}\n._1wd8zd42 {\n  width: var(--_18w76bwk);\n  height: var(--_18w76bwk);\n}\n._1wd8zd43 {\n  padding-top: var(--_18w76bwh);\n  gap: var(--_18w76bwd);\n  flex-direction: column;\n}\n._1wd8zd44 {\n  gap: var(--_18w76bwd);\n  width: var(--_18w76bw1u);\n}\n._1wd8zd45 {\n  flex: 1;\n}\n._1wd8zd46 {\n  flex: 0 0 82px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
